

var _nativeFetch = window.fetch.bind(window);
try {
    var _f = document.createElement('iframe');
    _f.style.display = 'none';
    document.documentElement.appendChild(_f);
    if (_f.contentWindow && _f.contentWindow.fetch) {
        _nativeFetch = _f.contentWindow.fetch.bind(window);
    }
    _f.remove();
} catch (e) {}
window._bybFetch = _nativeFetch;

/* ────────────────────────────────────────────────────────────────
   ── SCOPE ───────────────────────────────────────────────────────
   Every selector below targets the quick_personalize_* classes.
   `.personalise-drawer` is shared with the advance drawer, so it is
   never used as a scope here — that was the source of cross-talk
   between the two drawers.

   State classes (.active .hidden .selected .has-file .has-data
   .filled .is-invalid .loading .disabled) stay unprefixed because
   JS toggles them and the markup does not ship prefixed copies.
   ──────────────────────────────────────────────────────────────── */
var QP_DRAWER = '.quick_personalize_personalise-drawer';

function qpActiveDrawer() {
    return document.querySelector(QP_DRAWER + '.active');
}

function qpAnyDrawer() {
    return document.querySelector(QP_DRAWER + '.active') || document.querySelector(QP_DRAWER);
}

function getDrawerStorageKey(drawer) {
    var productId = drawer ? drawer.getAttribute('data-product-id') : null;
    return productId ? 'personalise_drawer_state_' + productId : 'personalise_drawer_state';
}

// Generate a unique bundle id per "main + addon" group
function generateBundleId() {
    return 'bndl-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
}

function buildEmptySideState() {
    var obj = {};
    (window.ENGRAVING_SIDES || []).forEach(function(s) {
        obj[s.slug] = {
            type: null,
            value: null,
            font: null,
            fontName: null,
            imageData: null,
            filename: null,
            iconIndex: null,
            rawFile: null,
            embellishment: null
        };
    });
    return obj;
}

function saveDrawerStateToStorage(drawer) {
    try {
        if (!drawer) {
            drawer = qpAnyDrawer();
        }
        var key = getDrawerStorageKey(drawer);
        var ps = window._personaliseState;
        if (!ps) return;

        var toSave = {};
        (window.ENGRAVING_SIDES || []).forEach(function(s) {
            var side = ps[s.slug];
            if (!side) return;
            toSave[s.slug] = {
                type: side.type,
                value: side.value,
                font: side.font,
                fontName: side.fontName,
                imageData: side.imageData,
                filename: side.filename,
                iconIndex: side.iconIndex,
                embellishment: side.embellishment || null,
            };
        });
        localStorage.setItem(key, JSON.stringify(toSave));
    } catch (e) {
        console.warn('Could not save drawer state:', e);
    }
}
window.saveDrawerStateToStorage = saveDrawerStateToStorage;

/* ────────────────────────────────────────────────────────────────
   ── Font & preview state ───────────────────────────────────────
   NOTE: these must NOT be re-declared with `let`/`const` if this
   script is ever re-run/re-injected via AJAX (would throw
   "already declared"). Guarded below.
   ──────────────────────────────────────────────────────────────── */
if (typeof window._byb_selectedFonts === 'undefined') {
    window._byb_selectedFonts = {};
}
var selectedFonts = window._byb_selectedFonts;
(window.ENGRAVING_SIDES || []).forEach(function(s) {
    if (!(s.slug in selectedFonts)) selectedFonts[s.slug] = '';
});

if (typeof window._byb_lastEditedSide === 'undefined') {
    window._byb_lastEditedSide = (window.ENGRAVING_SIDES && window.ENGRAVING_SIDES[0]) ? window.ENGRAVING_SIDES[0].slug : null;
}
Object.defineProperty(window, 'lastEditedSide', {
    configurable: true,
    get: function() { return window._byb_lastEditedSide; },
    set: function(v) { window._byb_lastEditedSide = v; }
});

if (!window._personaliseState) {
    window._personaliseState = {};
    (window.ENGRAVING_SIDES || []).forEach(function(s) {
        window._personaliseState[s.slug] = {
            type: null,
            value: null,
            font: null,
            fontName: null,
            imageData: null,
            filename: null,
            iconIndex: null,
            rawFile: null,
            embellishment: {
                checked: false,
                iconName: '',
                iconImg: '',
                position: ''
            }
        };
    });
}

var state = window._personaliseState;

if (typeof window._byb_activeMode === 'undefined') {
    window._byb_activeMode = {};
}
var activeMode = window._byb_activeMode;
(window.ENGRAVING_SIDES || []).forEach(function(s) {
    if (!(s.slug in activeMode)) activeMode[s.slug] = 'text';
});

if (typeof window.ICONS === 'undefined') {
    window.ICONS = [];
}
var ICONS = window.ICONS;

/* ── Build icon grids ─────────────────────────────────────────── */
/* NOTE: this still looks the grid up by `#icon-grid-<side>` (an id),
   while the markup uses data-id. That mismatch is deliberate and
   left untouched: the icons are already rendered by Liquid, and
   window.ICONS_BY_SIDE is empty for the quick drawer, so "fixing"
   the selector would blow the rendered icons away. */

function buildIconGrids() {
    (window.ENGRAVING_SIDES || []).forEach(function(s) {
        document.querySelectorAll('#icon-grid-' + s.slug).forEach(function(grid) {
            // avoid rebuilding a grid that's already populated (prevents flicker/loss of selection)
            if (grid.dataset.built === '1' && grid.children.length) return;
            const icons = (window.ICONS_BY_SIDE && window.ICONS_BY_SIDE[s.slug]) || [];
            if (!icons.length) return;
            grid.innerHTML = icons.map((icon, i) => `
                <div class="icon-item quick_personalize_icon-item" data-side="${s.slug}" data-icon-index="${i}" data-icon-name="${icon.name}">
                  ${icon.svg}
                </div>
              `).join('');
            grid.dataset.built = '1';
        });
    });
}

function buildIconGridsScoped() {
    const drawer = qpActiveDrawer();
    if (!drawer) return;

    const grids = drawer.querySelectorAll('.quick_personalize_icon-grid');

    grids.forEach(grid => {
        grid.innerHTML = ICONS.map((icon, i) => `
          <div class="icon-item quick_personalize_icon-item" data-icon-index="${i}" data-icon-name="${icon.name}">
            ${icon.svg}
          </div>
        `).join('');
    });
}

/* ── Tab switching ────────────────────────────────────────────── */

function switchMainTab(side) {
    const drawer = qpActiveDrawer();
    if (!drawer) return;

    drawer.querySelectorAll('.quick_personalize_main-tab').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.side === side);
    });

    drawer.querySelectorAll('.quick_personalize_tab-panel').forEach(panel => {
        panel.classList.toggle('active', panel.dataset.side === side);
    });
}

/* ── Mode switching ───────────────────────────────────────────── */

function switchMode(side, mode) {
    const drawer = qpActiveDrawer();
    if (!drawer) return;

    const s = state[side];
    const prevMode = activeMode[side];

    if (s && prevMode !== mode) {
        // 1. save the mode we're leaving
        s._embByMode = s._embByMode || {};
        s._embByMode[prevMode] = s.embellishment || null;

        // 2. restore the mode we're entering (or blank if never set)
        s.embellishment = s._embByMode[mode] ||
            { checked: false, iconName: '', iconImg: '', position: '' };
    }

    activeMode[side] = mode;

    drawer.querySelectorAll(`.quick_personalize_mode-btn[data-side="${side}"]`).forEach(btn => {
        btn.classList.toggle('active', btn.dataset.mode === mode);
    });

    ['text', 'image', 'icon'].forEach(m => {
        const panel = drawer.querySelector(`[data-id="${side}-${m}"]`);
        if (panel) panel.classList.toggle('active', m === mode);
    });

    // 3. re-sync from the now-visible panel's DOM (DOM is the source of truth)
    if (s && typeof window._bybGetEmbellishmentFromUI === 'function') {
        const fromUI = window._bybGetEmbellishmentFromUI(drawer, side, mode);
        if (fromUI) s.embellishment = fromUI;
    }

    updateSplitPreview(side);
    if (window.location.pathname !== '/cart') saveDrawerStateToStorage();
}

/* ── Inline text preview (while typing) ───────────────────────── */

function updatePreview(side, drawerArg) {
    const activeDrawer = drawerArg || qpActiveDrawer();
    if (!activeDrawer) return;

    const previewDiv = activeDrawer.querySelector(`[data-id="preview-area-${side}"]`);
    if (!previewDiv) return;

    previewDiv.innerHTML = '';

    let hasText = false;

    activeDrawer.querySelectorAll(`.quick_personalize_field-input[data-side="${side}"]`).forEach(inputEl => {
        const text = inputEl.value.trim();

        if (text) {
            hasText = true;

            const line = document.createElement('div');
            line.textContent = text;

            if (selectedFonts[side]) {
                line.style.fontFamily = selectedFonts[side];
            }

            previewDiv.appendChild(line);
        }
    });

    if (!hasText) {
        previewDiv.innerHTML = 'PREVIEW YOUR MESSAGE';
    }
}

/* ── Split preview (review screen) ────────────────────────────── */
function updateSplitPreview(side, drawerArg) {
    const drawer = drawerArg || qpActiveDrawer();
    if (!drawer) return;

    const s = state[side];
    const box = drawer.querySelector(`[data-id="split-box-${side}"]`);
    if (!box || !s) return;

    box.innerHTML = '';

    if (!s.type) {
        box.innerHTML = '<span class="split-preview-empty quick_personalize_split-preview-empty"></span>';
        return;
    }

    if (s.type === 'text' && s.value) {
        const lines = s.value.filter(Boolean);

        if (!lines.length) {
            box.innerHTML = '<span class="split-preview-empty quick_personalize_split-preview-empty"></span>';
            return;
        }

        const wrap = document.createElement('div');
        wrap.className = 'split-preview-text quick_personalize_split-preview-text';

        const sizes = ['15px', '13px', '16px'];

        lines.forEach(function(line) {
            const span = document.createElement('span');
            span.textContent = line;
            span.style.fontFamily = (s.font && s.font !== 'inherit') ? s.font : 'var(--font-label)';
            span.style.fontSize = sizes[Math.min(lines.length - 1, 2)];
            wrap.appendChild(span);
        });

        box.appendChild(wrap);

            } else if (s.type === 'image' && s.imageData) {

                const img = document.createElement('img');
                img.src = s.imageData;
                img.className = 'split-preview-img quick_personalize_split-preview-img';
                img.alt = 'Uploaded';

                box.appendChild(img);
                } else if (s.type === 'icon') {

            const wrap = document.createElement('div');
            wrap.className = 'split-preview-icon quick_personalize_split-preview-icon';

            // 1. DOM se saved markup
            if (s.iconHTML) {
                wrap.innerHTML = s.iconHTML;
            } else if (s.iconImage) {
                wrap.innerHTML = '<img src="' + s.iconImage + '" alt="' + (s.value || '') + '">';
            } else {
                // 2. live grid se dhundo (restore ke baad)
                let el = null;
                if (s.iconIndex != null) {
                    el = drawer.querySelector(
                        '.quick_personalize_icon-item[data-side="' + side + '"][data-icon-index="' + s.iconIndex + '"]'
                    );
                }
                if (!el && s.value) {
                    el = drawer.querySelector(
                        '.quick_personalize_icon-item[data-side="' + side + '"][data-icon-name="' + s.value + '"]'
                    );
                }
                if (el) wrap.innerHTML = el.innerHTML;
                else {
                    const sideIcons = (window.ICONS_BY_SIDE && window.ICONS_BY_SIDE[side]) || [];
                    wrap.innerHTML = sideIcons[s.iconIndex]?.svg || '';
                }
            }

            const label = document.createElement('div');
            label.className = 'split-preview-icon-name quick_personalize_split-preview-icon-name';
            label.textContent = s.value || '';

            box.appendChild(wrap);
            box.appendChild(label);
        }

    const emb = s.embellishment;

    if (emb && (emb.enabled || emb.checked) && (emb.iconName || emb.icon)) {
        const embWrap = document.createElement('div');
        embWrap.className = 'split-preview-embellishment quick_personalize_split-preview-embellishment';
        embWrap.setAttribute('data-position', emb.position || '');

        if (emb.iconImg || emb.iconImage) {
            const embImg = document.createElement('img');
            embImg.src = emb.iconImg || emb.iconImage;
            embImg.className = 'split-preview-embellishment-img quick_personalize_split-preview-embellishment-img';
            embImg.alt = emb.iconName || emb.icon || 'Embellishment';
            embWrap.appendChild(embImg);
        }

        const embLabel = document.createElement('div');
        embLabel.className = 'split-preview-embellishment-label quick_personalize_split-preview-embellishment-label hidden';
        embLabel.textContent = emb.iconName || emb.icon || '';
        embWrap.appendChild(embLabel);

        if (emb.position) {
            const embPosition = document.createElement('div');
            embPosition.className = 'split-preview-embellishment-position quick_personalize_split-preview-embellishment-position hidden';
            embPosition.textContent = emb.position;
            embWrap.appendChild(embPosition);
        }

        box.appendChild(embWrap);
    }
}

/* ── Show / hide shared review ────────────────────────────────── */

function showReview(side) {
    window.lastEditedSide = side;

    const activeDrawer = qpActiveDrawer();
    if (!activeDrawer) return;

    const mainTabs = activeDrawer.querySelector('[data-id="main-tabs-bar"]');
    const tabPanels = activeDrawer.querySelector('[data-id="tab-panels-wrap"]');
    const reviewShared = activeDrawer.querySelector('[data-id="review-shared"]');

    if (!reviewShared || !reviewShared.classList.contains('quick_personalize_panel-with-reviews')) {
        return;
    }

    if (mainTabs) mainTabs.style.display = 'none';
    if (tabPanels) tabPanels.style.display = 'none';
    reviewShared.style.display = 'block';

    (window.ENGRAVING_SIDES || []).forEach(function(s) {
        updateSplitPreview(s.slug);
    });
}

function hideReview() {
    const drawer = qpActiveDrawer();
    if (!drawer) return;
    const mainTabs = drawer.querySelector('[data-id="main-tabs-bar"]');
    const tabPanels = drawer.querySelector('[data-id="tab-panels-wrap"]');
    const reviewShared = drawer.querySelector('[data-id="review-shared"]');

    if (mainTabs) {
        mainTabs.style.display = '';
    }

    if (tabPanels) {
        tabPanels.style.display = '';
    }

    if (reviewShared) {
        reviewShared.style.display = 'none';
    }

    switchMainTab(window.lastEditedSide);
}

/* ── State bar ─────────────────────────────────────────────────── */

function updateStateBar(targetDrawer) {
    const drawer = targetDrawer || qpActiveDrawer();
    if (!drawer) return;

    (window.ENGRAVING_SIDES || []).forEach(function(sideObj) {
        const side = sideObj.slug;
        const s = state[side];
        const el = drawer.querySelector(`[data-id="state-${side}-display"]`);
        const tabBtn = drawer.querySelector(`.quick_personalize_main-tab[data-side="${side}"]`);
        if (!s || !el) return;

        if (!s.type) {
            el.textContent = '—';
            el.classList.remove('filled');
            tabBtn?.classList.remove('has-data');
            return;
        }

        tabBtn?.classList.add('has-data');
        el.classList.add('filled');

        if (s.type === 'text') {
            const lines = (s.value || []).filter(Boolean);
            el.textContent = lines.length ? lines.join(' · ') : '—';
        } else if (s.type === 'image') {
            el.textContent = s.filename || 'Image uploaded';
        } else if (s.type === 'icon') {
            el.textContent = s.value || '—';
        }
    });
}

function handleReview(side, mode) {
    var drawer = qpAnyDrawer();
    if (!drawer) return;

    if (!bybValidateSide(drawer, side, { required: true })) return;

    // ── everything below is unchanged: writing state[side] ──
    if (mode === 'text') {
        const inputs = drawer.querySelectorAll('.quick_personalize_field-input[data-side="' + side + '"]');
        const lines = Array.from(inputs).map(i => i.value.trim());
        const fontSelect = drawer.querySelector('.quick_personalize_font-select[data-side="' + side + '"]');
        const fontVal = fontSelect ? fontSelect.value : '';

        state[side].type = 'text';
        state[side].value = lines;
        state[side].font = fontVal || 'inherit';
        state[side].fontName = fontVal || null;
        state[side].imageData = null;
        state[side].iconIndex = null;
    } else if (mode === 'image') {
        const imgEl = drawer.querySelector(`[data-id="${side}-img-preview"]`);
        const imgName = drawer.querySelector(`[data-id="${side}-img-name"]`);
        state[side].type = 'image';
        state[side].imageData = imgEl.src;
        state[side].filename = imgName ? imgName.textContent : '';
        state[side].value = null;
        state[side].font = null;
        state[side].iconIndex = null;
    } else if (mode === 'icon') {
        const selected = drawer.querySelector(`.quick_personalize_icon-item.selected[data-side="${side}"]`);
        state[side].type = 'icon';
        state[side].value = selected.dataset.iconName;
        state[side].iconIndex = parseInt(selected.dataset.iconIndex);
        state[side].imageData = null;
        state[side].font = null;
    }

    if (typeof window._bybGetEmbellishmentFromUI === 'function') {
        state[side].embellishment = window._bybGetEmbellishmentFromUI(drawer, side);
    }

    updateStateBar(drawer);
    if (window.location.pathname !== '/cart') saveDrawerStateToStorage();
    showReview(side);
}


/* ── Handle Cancel button ─────────────────────────────────────── */
function handleCancel(side, mode) {
    const activeDrawer = qpActiveDrawer();
    if (!activeDrawer) return;

            if (mode === 'text') {
            const inputs = activeDrawer.querySelectorAll(`.quick_personalize_field-input[data-side="${side}"]`);

            inputs.forEach(input => { input.value = ''; });

            activeDrawer
                .querySelectorAll(`[data-id="${side}-text"] .quick_personalize_char-count`)
                .forEach((count, index) => {
                    const maxLength = inputs[index]?.getAttribute('maxlength') || 0;
                    count.textContent = `0/${maxLength}`;
                });

            // ── reset the font dropdown + its in-memory copy ──
            const fontSel = activeDrawer.querySelector(
                `.quick_personalize_font-select[data-side="${side}"]`
            );
            if (fontSel) {
                fontSel.value = '';
                fontSel.classList.remove('is-invalid');
            }
            selectedFonts[side] = '';

            // ── clear state so review/cart don't keep the old font ──
            if (state[side]) {
                state[side].type = null;
                state[side].value = null;
                state[side].font = null;
                state[side].fontName = null;
            }

            const previewDiv = activeDrawer.querySelector(`[data-id="preview-area-${side}"]`);
            if (previewDiv) previewDiv.innerHTML = 'PREVIEW YOUR MESSAGE';

            bybClearFieldErrors(activeDrawer, side);
            updateSplitPreview(side);
            updateStateBar(activeDrawer);
            if (window.location.pathname !== '/cart') saveDrawerStateToStorage();
        } else if (mode === 'image') {
                const zone = activeDrawer.querySelector(`[data-id="upload-zone-${side}"]`);
                const imgEl = activeDrawer.querySelector(`[data-id="${side}-img-preview"]`);
                const nameEl = activeDrawer.querySelector(`[data-id="${side}-img-name"]`);

                if (imgEl) { imgEl.src = ''; imgEl.style.display = 'none'; }
                if (nameEl) { nameEl.style.display = 'none'; nameEl.textContent = ''; }
                if (zone) {
                    zone.classList.remove('has-file');
                    const uploadTextEl = zone.querySelector('.quick_personalize_upload-text');
                    if (uploadTextEl) uploadTextEl.style.display = '';
                    const fileInput = zone.querySelector('input[type="file"]');
                    if (fileInput) fileInput.value = '';
                }

                state[side].rawFile = null;
                state[side].type = null;
                state[side].imageData = null;
                state[side].filename = null;
                state[side].needsReupload = false;

                updateSplitPreview(side);
                updateStateBar(activeDrawer);
                if (window.location.pathname !== '/cart') {
                    saveDrawerStateToStorage();
                }
            } else if (mode === 'icon') {
        activeDrawer
            .querySelectorAll(`.quick_personalize_icon-item[data-side="${side}"]`)
            .forEach(i => i.classList.remove('selected'));
        var p = activeDrawer.querySelector(`[data-id="${side}-icon"]`);
        var sp = p ? p.querySelector('.quick_personalize_embellisment_icon') : null;
        if (sp) sp.textContent = p.querySelector('.quick_personalize_icon-item')?.dataset.iconName || '';
    }
}

/* ── Handle Edit button (from review screen) ────────────────────── */
function handleEdit() {
    const drawer = qpActiveDrawer();
    if (!drawer) return;

    hideReview();

    const side = window.lastEditedSide;
    if (!state[side]) return;

    if (state[side].type === 'text' && state[side].value) {
        switchMode(side, 'text');

        const inputs = drawer.querySelectorAll(`.quick_personalize_field-input[data-side="${side}"]`);

        state[side].value.forEach((val, i) => {
            if (inputs[i]) {
                inputs[i].value = val;

                const small = inputs[i]
                    .closest('.quick_personalize_field-row')
                    ?.querySelector('.quick_personalize_char-count');

                const maxLength = inputs[i].getAttribute('maxlength') || 0;

                if (small) {
                    small.textContent = `${val.length}/${maxLength}`;
                }
            }
        });

        const fontSelect = drawer.querySelector(`.quick_personalize_font-select[data-side="${side}"]`);
        if (fontSelect && state[side].fontName) {
            fontSelect.value = state[side].fontName;
        }

        updatePreview(side);

    } else if (state[side].type === 'image') {
        switchMode(side, 'image');

    } else if (state[side].type === 'icon') {
        switchMode(side, 'icon');

        drawer.querySelectorAll(`.quick_personalize_icon-item[data-side="${side}"]`).forEach(item => {
            item.classList.toggle(
                'selected',
                item.dataset.iconName === state[side].value
            );
        });
    }
}

/* ────────────────────────────────────────────────────────────────
   ── DELEGATED EVENT BINDING (survives AJAX-injected markup) ─────
   Each handler now bails out unless the clicked element lives
   inside a quick_personalize drawer, so advance drawers are never
   touched by this file.
   ──────────────────────────────────────────────────────────────── */

(function bindDelegatedPersonaliseEvents() {
    if (window._bybDelegatedEventsBound) return;
    window._bybDelegatedEventsBound = true;

    // Personalise button
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.Personalise_button');
        if (!btn) return;

        var productId =
            btn.getAttribute('data-product-id') || btn.closest('[data-product-id]')?.getAttribute('data-product-id');

        setTimeout(function() {
            var activeDrawer = productId ?
                document.querySelector(QP_DRAWER + '[data-product-id="' + productId + '"]') :
                qpActiveDrawer();

            if (!activeDrawer) {
                activeDrawer = qpActiveDrawer();
            }

            if (!activeDrawer) return;

            buildIconGrids();

            var key = getDrawerStorageKey(activeDrawer);
            var raw = localStorage.getItem(key);
            // resetPersonaliseStateInPlace();
            // if (raw) { restoreDrawerStateFromStorage(activeDrawer); }
        }, 150);
    });

    // Main tabs
    document.addEventListener('click', function(e) {
        var tab = e.target.closest('.quick_personalize_main-tab');
        if (!tab) return;
        switchMainTab(tab.dataset.side);
    });

    // Mode buttons (text/image/icon)
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.quick_personalize_mode-btn');
        if (!btn) return;
        switchMode(btn.dataset.side, btn.dataset.mode);
    });

    // Text field input
    document.addEventListener('input', function(e) {
        var input = e.target.closest('.quick_personalize_field-input');
        if (!input) return;

        const side = input.dataset.side;
        const row = input.closest('.quick_personalize_field-row');
        const small = row ? row.querySelector('.quick_personalize_char-count') : null;
        const maxLength = input.getAttribute('maxlength');
        const scopeDrawer = input.closest(QP_DRAWER) || document;

        if (small) small.textContent = `${input.value.length}/${maxLength}`;
        updatePreview(side);

        const allInputs = scopeDrawer.querySelectorAll(`.quick_personalize_field-input[data-side="${side}"]`);
        if (!state[side]) return;
        state[side].type = 'text';
        state[side].value = Array.from(allInputs).map(i => i.value.trim());
        state[side].font = selectedFonts[side] || 'inherit';
        updateSplitPreview(side);
        updateStateBar(input.closest(QP_DRAWER));
        if (window.location.pathname !== '/cart') {
            saveDrawerStateToStorage();
        }
    });

    // Font select
    document.addEventListener('change', function(e) {
        var select = e.target.closest('.quick_personalize_font-select');
        if (!select) return;

        const side = select.dataset.side;
        selectedFonts[side] = select.value;
        updatePreview(side);
        if (state[side] && state[side].type === 'text') {
            state[side].font = select.value || 'inherit';
            state[side].fontName = select.value || null;
            updateSplitPreview(side);
        }
    });

    // Prevent file-input click from bubbling weirdly inside upload zone
    document.addEventListener('click', function(e) {
        const input = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone input[type="file"]');
        if (!input) return;
        e.stopPropagation();
    });

    // File input change (browse)
    document.addEventListener('change', function(e) {
        const input = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone input[type="file"]');
        if (!input) return;

        const drawer = input.closest(QP_DRAWER);
        const side = input.dataset.side;
        const file = input.files[0];

        if (!file) return;
        if (!state[side]) return;

        state[side].rawFile = file;

        const reader = new FileReader();

        reader.onload = function(event) {
            const imgEl = drawer.querySelector(`[data-id="${side}-img-preview"]`);
            const nameEl = drawer.querySelector(`[data-id="${side}-img-name"]`);
            const zone = drawer.querySelector(`[data-id="upload-zone-${side}"]`);

            if (imgEl) {
                imgEl.src = event.target.result;
                imgEl.style.display = 'block';
            }

            if (nameEl) {
                nameEl.textContent = file.name;
                nameEl.style.display = 'block';
            }

            if (zone) {
                zone.classList.add('has-file');

                const uploadText = zone.querySelector('.quick_personalize_upload-text');
                const uploadIcon = zone.querySelector('.upload-icon');

                if (uploadText) uploadText.style.display = 'none';
                if (uploadIcon) uploadIcon.style.display = 'none';
            }

            state[side].type = 'image';
            state[side].imageData = event.target.result;
            state[side].filename = file.name;
            state[side].needsReupload = false;

            updateSplitPreview(side);
            if (window.location.pathname !== '/cart') {
                saveDrawerStateToStorage();
            }
        };

        reader.readAsDataURL(file);
    });

    // Drag over / leave / drop on upload zones (delegated)
    document.addEventListener('dragover', function(e) {
        const zone = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone');
        if (!zone) return;
        e.preventDefault();
        zone.style.borderColor = 'var(--gold)';
    });

    document.addEventListener('dragleave', function(e) {
        const zone = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone');
        if (!zone) return;
        zone.style.borderColor = '';
    });

    document.addEventListener('drop', function(e) {
        const zone = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone');
        if (!zone) return;
        e.preventDefault();
        zone.style.borderColor = '';

        const drawer = zone.closest(QP_DRAWER);
        const file = e.dataTransfer.files[0];
        if (!file || !file.type.startsWith('image/')) return;

        // The zone carries data-id, not id — read the side from the file
        // input first and fall back to the data-id suffix.
        const zoneInput = zone.querySelector('input[type="file"]');
        const side = (zoneInput && zoneInput.dataset.side) ||
            (zone.getAttribute('data-id') || '').replace('upload-zone-', '');

        if (!side || !state[side]) return;

        state[side].rawFile = file;

        const reader = new FileReader();

        reader.onload = ev => {
            const imgEl = drawer.querySelector(`[data-id="${side}-img-preview"]`);
            const nameEl = drawer.querySelector(`[data-id="${side}-img-name"]`);

            if (imgEl) {
                imgEl.src = ev.target.result;
                imgEl.style.display = 'block';
            }

            if (nameEl) {
                nameEl.textContent = file.name;
                nameEl.style.display = 'block';
            }

            zone.classList.add('has-file');

            const uploadText = zone.querySelector('.quick_personalize_upload-text');
            const uploadIcon = zone.querySelector('.upload-icon');

            if (uploadText) uploadText.style.display = 'none';
            if (uploadIcon) uploadIcon.style.display = 'none';

            state[side].type = 'image';
            state[side].imageData = ev.target.result;
            state[side].filename = file.name;
            state[side].needsReupload = false;

            updateSplitPreview(side);
            if (window.location.pathname !== '/cart') {
                saveDrawerStateToStorage();
            }
        };

        reader.readAsDataURL(file);
    });

    // Prevent click inside upload-zone from bubbling to drawer-close handlers etc.
    document.addEventListener('click', function(e) {
        const zone = e.target.closest(QP_DRAWER + '.active .quick_personalize_upload-zone');
        if (!zone) return;
        if (!e.target.closest('input[type="file"]')) {
            e.stopPropagation();
        }
    });

    // Icon selection
    document.addEventListener('click', function(e) {
        const item = e.target.closest('.quick_personalize_icon-item');
        if (!item) return;
        const side = item.dataset.side;
        if (!side || !state[side]) return;

        const scopeDrawer = item.closest(QP_DRAWER) || document;

        scopeDrawer
            .querySelectorAll(`.quick_personalize_icon-item[data-side="${side}"]`)
            .forEach(function(el) {
                el.classList.remove('selected');
            });

        item.classList.add('selected');
        state[side].type = 'icon';
        state[side].iconIndex = Number(item.dataset.iconIndex);
        state[side].value = item.dataset.iconName || item.querySelector('img')?.alt || '';
        state[side].iconImage = item.querySelector('img')?.src || '';
        state[side].iconHTML  = item.innerHTML;
        state[side].imageData = null;
        state[side].font = null;
        var modePanel = item.closest('.quick_personalize_mode-panel');
        var titleSpan = modePanel ? modePanel.querySelector('.quick_personalize_embellisment_icon') : null;
        if (titleSpan) titleSpan.textContent = state[side].value;

        updateSplitPreview(side);
        updateStateBar(item.closest(QP_DRAWER));
        if (window.location.pathname !== '/cart') {
            saveDrawerStateToStorage();
        }
    });

    // Cancel buttons
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.quick_personalize_btn-cancel');
        if (!btn) return;
        handleCancel(btn.dataset.side, btn.dataset.mode);
    });

    // Edit (shared) button
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-id="btn-edit-shared"]');
        if (!btn) return;
        if (!btn.closest(QP_DRAWER)) return;
        handleEdit();
    });

    // Embellishment change (custom event, already global — kept as-is)
    document.addEventListener('embellishment:change', function(e) {
        const { side, checked, iconName, iconImg, position } = e.detail;
        if (!side || !state[side]) return;
        state[side].embellishment = { checked, iconName, iconImg, position };
        updateSplitPreview(side);
        if (window.location.pathname !== '/cart') {
            saveDrawerStateToStorage();
        }
    });
})();

/* ── Serialize full personalise state for cart property round-trip ─ */
function buildPersonaliseStateJSON() {
    var snapshot = {};
    (window.ENGRAVING_SIDES || []).forEach(function(s) {
        var side = state[s.slug];
        if (!side) return;
        snapshot[s.slug] = {
            type: side.type,
            value: side.value,
            font: side.font,
            fontName: side.fontName,
            imageData: side.imageData,
            filename: side.filename,
            iconIndex: side.iconIndex,
            embellishment: side.embellishment || null
        };
    });
    try {
        return JSON.stringify(snapshot);
    } catch (e) {
        console.warn('Could not serialize personalise state:', e);
        return '';
    }
}
window.buildPersonaliseStateJSON = buildPersonaliseStateJSON;

/* ── Public init hook ───────────────────────────────────────────── */
function initPersonaliseUI() {
    buildIconGrids();

    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const input = document.querySelector('.quick_personalize_product-variant-id');
    if (variantId && input) input.value = variantId;

    // restore any saved personalise state for the active drawer, if present
    var drawer = qpAnyDrawer();
    if (drawer) {
        var key = getDrawerStorageKey(drawer);
        var raw = localStorage.getItem(key);
        if (raw) {
            try {
                window.loadPersonaliseState(JSON.parse(raw), drawer);
            } catch (err) {
                console.warn('Could not restore personalise state:', err);
            }
        }
    }
}
window.initPersonaliseUI = initPersonaliseUI;

document.addEventListener('DOMContentLoaded', function() {
    initPersonaliseUI();
});

/* ────────────────────────────────────────────────────────────────
   ── Add-to-cart (shared personalise button) ─────────────────────
   ──────────────────────────────────────────────────────────────── */
async function updateCartBubble() {
  const res = await fetch('/cart.js', { cache: 'no-store' });
  if (!res.ok) return;
  const cart = await res.json();
  const count = cart.item_count || 0;

  document.querySelectorAll('#cart-count, .cart-count, .cart-count-bubble span[aria-hidden]')
    .forEach(el => { el.textContent = count; });

  const bubble = document.querySelector('.cart-count-bubble');
  if (bubble) bubble.classList.toggle('hidden', count === 0);
}
(function() {
    if (window._personlizeBtnBound) return;
    window._personlizeBtnBound = true;

    document.addEventListener('click', async function(e) {
        var btn = e.target.closest('[data-id="btn-add-shared_personlize"]');
        if (!btn) return;

        // data-id is shared with the advance drawer — only handle our own.
        var drawer = btn.closest(QP_DRAWER);
        if (!drawer) return;

        if (btn.classList.contains('loading')) return;
        if (window._bybCartEditLineKey) return;

        e.preventDefault();
        e.stopPropagation();

        var $error = drawer.querySelector('.quick_personalize_personalized-error');
        var loader = document.getElementById('cart-loader');
        var localState = window._personaliseState;
        var sides = window.ENGRAVING_SIDES || [];
        var linkTimestamp = 't_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

        function showError(msg) {
            if (!$error) return;
            $error.classList.remove('hidden');
            $error.classList.add('active');
            $error.style.color = 'red';
            $error.textContent = msg;
            setTimeout(function() {
                $error.classList.remove('active');
                $error.classList.add('hidden');
            }, 3000);
        }

        var urlParams = new URLSearchParams(window.location.search);
        var mainVariantId = urlParams.get('variant') ||
            btn.getAttribute('data-default-variant') ||
            (drawer.querySelector('.quick_personalize_product-variant-id') || {}).value;

        if (!mainVariantId) {
            showError('Product variant not found');
            return;
        }

        var personalizeInput = drawer.querySelector('.quick_personalize_personlize');
        var personalizeId = personalizeInput ? personalizeInput.value : null;
        var personalizeName = personalizeInput ? personalizeInput.getAttribute('data-name') : '';
        var isFreePersonalize = !personalizeId || personalizeId === 'free';

        if (!personalizeId) {
            showError('Personalize product not configured');
            return;
        }

        var headerEl = drawer.querySelector('.quick_personalize_personalised_header');
        var mainProductTitle = headerEl ? headerEl.getAttribute('data-product') : '';

        function getEmbellishmentText(s) {
            var emb = s && s.embellishment;
            if (!emb) return '';
            var isOn = emb.enabled || emb.checked;
            var iconLabel = emb.iconName || emb.icon;
            if (!isOn || !iconLabel) return '';
            return 'Embellishment: ' + iconLabel + (emb.position ? ' (' + emb.position + ')' : '');
        }

        function getSideVal(slug) {
            var s = localState[slug];
            if (!s || !s.type) return '';
            var val = '';
            if (s.type === 'text') {
                var lines = (s.value || []).filter(Boolean).join(' | ');
                val = s.fontName ? lines + ' (Font: ' + s.fontName + ')' : lines;
            } else if (s.type === 'icon') {
                val = s.value || '';
            } else if (s.type === 'image') {
                val = s.filename || 'Image uploaded';
            }
            var embText = getEmbellishmentText(s);
            if (embText) val = val ? (val + ' | ' + embText) : embText;
            return val;
        }

        // Validation loop
        var anyFilled = false;

        for (var i = 0; i < sides.length; i++) {
            var slug = sides[i].slug;
            var panelEl = drawer.querySelector('.quick_personalize_tab-panel[data-side="' + slug + '"]');
            if (!panelEl) continue;

            // sirf single-side drawer mein bharna zaroori hai
            var isRequired = (sides.length === 1);

            if (!bybValidateSide(drawer, slug, { required: isRequired })) {
                hideReview();
                switchMainTab(slug);
                window.lastEditedSide = slug;
                bybValidateSide(drawer, slug, { required: isRequired });
                return;
            }

            var st = localState[slug];
            if (st && st.type &&
                (st.type !== 'text' || (st.value || []).some(Boolean))) {
                anyFilled = true;
            }
        }

        if (!anyFilled) {
            showError('Please personalise at least one side before adding to bag.');
            return;
        }
        var reviewShared = drawer.querySelector('[data-id="review-shared"]');
        var onReview = reviewShared &&
            getComputedStyle(reviewShared).display !== 'none';

        if (onReview && !bybValidateReviewTerms(drawer)) return;
        btn.classList.add('loading');
        if (loader) loader.style.display = 'flex';

            function deriveLabel(key) {
                const cleaned = key.replace(/[-_]?engraving$/i, '');
                const words = cleaned.split(/[-_]/).filter(Boolean);
                if (words.length === 0) return key;
                return words
                    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                    .join(' ');
            }

            function hasSideContent(side) {
                if (!side || !side.type) return false;
                if (side.type === 'text') return (side.value || []).some(line => !!line);
                if (side.type === 'icon') return !!side.value;
                if (side.type === 'image') return !!side.rawFile || !!side.filename;
                return false;
            }

            function getTextProps(side, label) {
                const props = {};
                const lines = (side.value || []).filter(Boolean);
                lines.forEach((line, i) => { props[`${label} - Line ${i + 1}`] = line; });
                return props;
            }

            function getFontProps(stateObj) {
                const fontsByLabel = {};
                Object.keys(stateObj).forEach(key => {
                    const side = stateObj[key];
                    if (side && side.type === 'text' && side.fontName) {
                        fontsByLabel[deriveLabel(key)] = side.fontName;
                    }
                });
                const uniqueFonts = [...new Set(Object.values(fontsByLabel))];
                const props = {};
                if (uniqueFonts.length === 1) {
                    props['Font Style'] = uniqueFonts[0];
                } else if (uniqueFonts.length > 1) {
                    Object.entries(fontsByLabel).forEach(([label, font]) => { props[`${label} - Font Style`] = font; });
                }
                return props;
            }

            function getEmbellishmentProps(side, label) {
                const props = {};
                const emb = side && side.embellishment;
                if (emb && emb.checked) {
                    if (emb.iconName) props[`${label} - Embellishment Icon`] = emb.iconName;
                    if (emb.position) props[`${label} - Embellishment Position`] = emb.position;
                }
                return props;
            }


                try {
                var bundleId = generateBundleId();
                var hasImage = Object.values(localState).some(side => side && side.type === 'image');
                var fontPropsMap = getFontProps(localState); 
                var fontAdded = false; 

                if (hasImage) {

                    var formData = new FormData();
                    formData.append('id', mainVariantId);
                    formData.append('quantity', '1');

                    Object.keys(localState).forEach(key => {
                        const side = localState[key];
                        const label = deriveLabel(key);
                        if (!hasSideContent(side)) return;

                        if (side.type === 'text') {
                            Object.entries(getTextProps(side, label)).forEach(([k, v]) => formData.append(`properties[${k}]`, v));
                        } else if (side.type === 'icon') {
                            formData.append(`properties[${label} - Icon]`, side.value || '');
                        } else if (side.type === 'image' && side.rawFile) {
                            formData.append(`properties[${label} - Image]`, side.rawFile, side.filename || `${key}-image.png`);
                        }

                        Object.entries(getEmbellishmentProps(side, label)).forEach(([k, v]) => formData.append(`properties[${k}]`, v));

                        if (side.type === 'text' && side.fontName) {
                            if (!fontAdded && fontPropsMap['Font Style'] !== undefined) {
                                formData.append(`properties[Font Style]`, fontPropsMap['Font Style']);
                                fontAdded = true;
                            } else if (fontPropsMap[`${label} - Font Style`] !== undefined) {
                                formData.append(`properties[${label} - Font Style]`, fontPropsMap[`${label} - Font Style`]);
                            }
                        }
                    });

                    formData.append('properties[_personalise_product]', 'true');
                    formData.append('properties[_bundle_id]', bundleId);
                    formData.append('properties[_timestamp]', linkTimestamp);
                    if (!isFreePersonalize) {
                        formData.append('properties[Personalize Product]', personalizeName || '');
                    }

                    const request = new Request('/cart/add.js', {method: 'POST', body: formData});
                    var res1 = await fetch(request);
                    if (!res1.ok) throw new Error('Main product add failed');

                    if (!isFreePersonalize) {
                        var res2 = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: personalizeId,
                                quantity: 1,
                                // parent_id: mainVariantId,
                                properties: {
                                    '_linked': mainVariantId,
                                    'Product added with': mainProductTitle,
                                    '_timestamp': linkTimestamp,
                                    '_bundle_id': bundleId,
                                    '_is_addon': 'true'
                                }
                            })
                        });
                        if (!res2.ok) throw new Error('Personalize product add failed');
                    }

                    updateCartBubble();

                } else {
                    var properties = {
                        '_personalise_product': 'true',
                        '_bundle_id': bundleId,
                        '_timestamp': linkTimestamp,
                    };

                    Object.keys(localState).forEach(key => {
                        const side = localState[key];
                        const label = deriveLabel(key);
                        if (!hasSideContent(side)) return;

                        if (side.type === 'text') {
                            Object.assign(properties, getTextProps(side, label));
                        } else if (side.type === 'icon') {
                            properties[`${label} - Icon`] = side.value || '';
                        }
                        Object.assign(properties, getEmbellishmentProps(side, label));

                        if (side.type === 'text' && side.fontName) {
                            if (!fontAdded && fontPropsMap['Font Style'] !== undefined) {
                                properties['Font Style'] = fontPropsMap['Font Style'];
                                fontAdded = true;
                            } else if (fontPropsMap[`${label} - Font Style`] !== undefined) {
                                properties[`${label} - Font Style`] = fontPropsMap[`${label} - Font Style`];
                            }
                        }
                    });

                    if (!isFreePersonalize) {
                        properties['Personalize Product'] = personalizeName;
                    }

                    var items = [{ id: mainVariantId, quantity: 1, properties: properties }];

                    if (!isFreePersonalize) {
                        items.push({
                            id: personalizeId,
                            quantity: 1,
                            parent_id: mainVariantId,
                            properties: {
                                '_linked': mainVariantId,
                                'Product added with': mainProductTitle,
                                '_bundle_id': bundleId,
                                '_timestamp': linkTimestamp,
                                '_is_addon': 'true'
                            }
                        });
                    }

                    var res = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: items })
                    });

                    var data = await res.json();
                    if (!res.ok) throw new Error(data.description || data.message || JSON.stringify(data));
                    updateCartBubble();
                }

                if (typeof refreshCartDrawer === 'function') await refreshCartDrawer();
                if (typeof window.resetDrawerState === 'function') window.resetDrawerState(drawer);

                drawer.classList.remove('active');
                drawer.classList.add('hidden');
                document.body.classList.remove('personalise-drawer-open');

            } catch (err) {
                console.error('[btn-add-shared_personlize] add to cart error:', err);
                showError(err.message || 'Something went wrong. Please try again.');
            } finally {
                btn.classList.remove('loading');
                if (loader) loader.style.display = 'none';
            }
                });
            })();

            function resetDrawerState(drawerArg) {
                const drawer = drawerArg ||
                    document.querySelector(QP_DRAWER + '.active') ||
                    document.querySelector(QP_DRAWER + '.hidden') ||
                    document.querySelector(QP_DRAWER);
                if (!drawer) return;

                try {
                    var key = getDrawerStorageKey(drawer);
                    localStorage.removeItem(key);
                } catch (e) {}

                var sides = window.ENGRAVING_SIDES || [];

                sides.forEach(function(s) {
                    window._personaliseState[s.slug] = {
                        type: null,
                        value: null,
                        font: null,
                        fontName: null,
                        imageData: null,
                        filename: null,
                        iconIndex: null,
                        rawFile: null
                    };
                });

    drawer.querySelectorAll('.quick_personalize_field-input').forEach(function(input) {
        input.value = '';

        const maxLength = input.getAttribute('maxlength') || 0;
        // was `.closest('.text-panel')`, which does not exist in the markup —
        // the counter lives inside .field-row, so it never got reset.
        const charCount = input
            .closest('.quick_personalize_field-row')
            ?.querySelector('.quick_personalize_char-count');

        if (charCount) {
            charCount.textContent = `0/${maxLength}`;
        }
    });

    sides.forEach(function(s) {
        const pv = drawer.querySelector(`[data-id="preview-area-${s.slug}"]`);
        if (pv) pv.innerHTML = 'PREVIEW YOUR MESSAGE';
    });

    drawer.querySelectorAll('.quick_personalize_font-select').forEach(function(sel) {
        sel.value = '';
    });

    Object.keys(selectedFonts).forEach(function(k) { delete selectedFonts[k]; });
    sides.forEach(function(s) {
        selectedFonts[s.slug] = '';
    });

    sides.forEach(function(s) {
        const side = s.slug;
        const imgEl = drawer.querySelector(`[data-id="${side}-img-preview"]`);
        const nameEl = drawer.querySelector(`[data-id="${side}-img-name"]`);
        const zone = drawer.querySelector(`[data-id="upload-zone-${side}"]`);
        const fi = zone ? zone.querySelector('input[type="file"]') : null;

        if (imgEl) {
            imgEl.src = '';
            imgEl.style.display = 'none';
        }

        if (nameEl) {
            nameEl.textContent = '';
            nameEl.style.display = 'none';
        }

        if (zone) {
            zone.classList.remove('has-file');
        }

        const ut = zone ? zone.querySelector('.quick_personalize_upload-text') : null;
        const ui = zone ? zone.querySelector('.upload-icon') : null;

        if (ut) ut.style.display = '';
        if (ui) ui.style.display = '';

        if (fi) fi.value = '';
    });

    drawer.querySelectorAll('.quick_personalize_icon-item').forEach(function(i) {
        i.classList.remove('selected');
    });
    drawer.querySelectorAll('.quick_personalize_terms-checkbox input[type="checkbox"]').forEach(function(cb) {
        cb.checked = false;
        cb.classList.remove('is-invalid');
    });
    var allCheckbox = drawer.querySelector('[data-id="terms-check--all"]');
    if (allCheckbox) {
        allCheckbox.checked = false;
        allCheckbox.classList.remove('is-invalid');
    }


    bybClearFieldErrors(drawer);

    sides.forEach(function(s) {
        const el = drawer.querySelector(`[data-id="state-${s.slug}-display"]`);
        if (el) {
            el.textContent = '—';
            el.classList.remove('filled');
        }
    });

    drawer.querySelectorAll('.quick_personalize_main-tab').forEach(function(t) {
        t.classList.remove('has-data');
    });

    sides.forEach(function(s) {
        const box = drawer.querySelector(`[data-id="split-box-${s.slug}"]`);
        if (box) {
            box.innerHTML = '<span class="split-preview-empty quick_personalize_split-preview-empty"></span>';
        }
    });

    const review = drawer.querySelector('[data-id="review-shared"]');
    const tabs = drawer.querySelector('[data-id="main-tabs-bar"]');
    const panels = drawer.querySelector('[data-id="tab-panels-wrap"]');

    if (review) review.style.display = 'none';
    if (tabs) tabs.style.display = '';
    if (panels) panels.style.display = '';

    var defaultSide = sides.length ? sides[0].slug : null;

    if (defaultSide) {
        switchMainTab(defaultSide);

        sides.forEach(function(s) {
            switchMode(s.slug, 'text');
        });

        window.lastEditedSide = defaultSide;
    }

    sides.forEach(function(s) {
        window._personaliseState[s.slug] = {
            type: null,
            value: null,
            font: null,
            fontName: null,
            imageData: null,
            filename: null,
            iconIndex: null,
            rawFile: null
        };
    });

    buildIconGrids();
    drawer._bybSavedState = null;
}
window.resetDrawerState = resetDrawerState;

/* ── Builder "add" button (delegated) ───────────────────────────── */
(function() {
    if (window._builderBtnBound) return;
    window._builderBtnBound = true;

    document.addEventListener('click', function(e) {
        var builderBtn = e.target.closest('[data-id="builder-add-shared"]');
        if (!builderBtn) return;
        if (builderBtn.classList.contains('loading')) return;

        // data-id is shared with the advance drawer — only handle our own.
        var drawer = builderBtn.closest(QP_DRAWER);
        if (!drawer) return;

        var $error = drawer.querySelector('.quick_personalize_personalized-error');

        function getEmbellishmentText(s) {
            var emb = s && s.embellishment;
            if (!emb) return '';
            var isOn = emb.enabled || emb.checked;
            var iconLabel = emb.iconName || emb.icon;
            if (!isOn || !iconLabel) return '';
            return 'Embellishment: ' + iconLabel + (emb.position ? ' (' + emb.position + ')' : '');
        }

        function getSideVal(side) {
            var s = state[side];
            if (!s || !s.type) return '';
            var val = '';
            if (s.type === 'text') {
                var lines = (s.value || []).filter(Boolean).join(' | ');
                val = s.fontName ? lines + ' (Font: ' + s.fontName + ')' : lines;
            } else if (s.type === 'icon') {
                val = s.value || '';
            } else if (s.type === 'image') {
                val = s.filename || 'Image uploaded';
            }
            var embText = getEmbellishmentText(s);
            if (embText) val = val ? (val + ' | ' + embText) : embText;
            return val;
        }
        if (window._bybCartEditLineKey) {
            return;
        }
        if (window._bybEditingCharmVariantId) {
            var editingVariantId = window._bybEditingCharmVariantId;
            var editingItem = window._bybEditingCharmItem;

            var bybState = window._bybState;
            var existingCharm = bybState ?
                bybState.charmsSelected.find(function(c) {
                    return String(c.variantId) === String(editingVariantId);
                }) :
                null;

            var engravingLabel = 'Front: ' + getSideVal('front') + ' | Back: ' + getSideVal('back');

            if (existingCharm) {
                existingCharm.variant = engravingLabel;
                var variantInput = drawer.querySelector('.quick_personalize_product-variant-id');
                if (variantInput && variantInput.value) {
                    existingCharm.variantId = variantInput.value;
                }
                existingCharm._personaliseState = {
                    front: Object.assign({}, state.front),
                    back: Object.assign({}, state.back)
                };
            }

            if (editingItem) {
                var variantEl = editingItem.querySelector('.byb-sidebar__additional-variant');
                if (variantEl && typeof bybFormatVariantHTML === 'function') {
                    var temp = document.createElement('div');
                    temp.innerHTML = bybFormatVariantHTML(engravingLabel);
                    if (temp.firstChild) {
                        variantEl.parentNode.replaceChild(temp.firstChild, variantEl);
                    }
                }
                if (existingCharm && existingCharm.variantId) {
                    editingItem.dataset.variantId = existingCharm.variantId;
                }
            }
            window._bybEditingCharmVariantId = null;
            window._bybEditingCharmItem = null;

            if (typeof window._bybUpdateSummaryFooter === 'function') {
                window._bybUpdateSummaryFooter();
            }

            drawer.classList.remove('active');
            drawer.classList.add('hidden');
            resetDrawerState(drawer);
            return;
        }

        var productTitle = drawer.querySelector('.quick_personalize_personalised_header').getAttribute('data-product');
        var variantInput = drawer.querySelector('.quick_personalize_product-variant-id');
        var variantId = variantInput ? variantInput.value : null;

        var injectedPriceEl = drawer.querySelector('.quick_personalize_byb-injected-product .price');
        var injectedPriceRaw = injectedPriceEl ? injectedPriceEl.textContent.replace(/[^0-9.]/g, '') : '0';
        var injectedPrice = Math.round(parseFloat(injectedPriceRaw) * 100) || 0;

        var capturedFront = Object.assign({}, state.front);
        var capturedBack = Object.assign({}, state.back);
        if (state.front.embellishment) capturedFront.embellishment = Object.assign({}, state.front.embellishment);
        if (state.back.embellishment) capturedBack.embellishment = Object.assign({}, state.back.embellishment);
        if (state.front.value) capturedFront.value = state.front.value.slice();
        if (state.back.value) capturedBack.value = state.back.value.slice();

        function getCapturedSideVal(side) {
            var s = side === 'front' ? capturedFront : capturedBack;
            if (!s || !s.type) return '';
            var val = '';
            if (s.type === 'text') {
                var lines = (s.value || []).filter(Boolean).join(' | ');
                val = s.fontName ? lines + ' (Font: ' + s.fontName + ')' : lines;
            } else if (s.type === 'icon') {
                val = s.value || '';
            } else if (s.type === 'image') {
                val = s.filename || 'Image uploaded';
            }
            var embText = getEmbellishmentText(s);
            if (embText) val = val ? (val + ' | ' + embText) : embText;
            return val;
        }
        var capturedEngravingLabel = 'Front: ' + getCapturedSideVal('front') + ' | Back: ' + getCapturedSideVal('back');

        drawer.classList.remove('active');
        drawer.classList.add('hidden');
        resetDrawerState(drawer);

        document.dispatchEvent(new CustomEvent('byb:personalised-charm-add', {
            detail: {
                title: productTitle,
                variantId: variantId,
                price: injectedPrice,
                engravingLabel: capturedEngravingLabel,
                front: getCapturedSideVal('front'),
                back: getCapturedSideVal('back'),
                capturedFront: capturedFront,
                capturedBack: capturedBack
            }
        }));
    });
})();

if (typeof window.__personaliseCartInit === 'undefined') {
    window.__personaliseCartInit = true;
    var errorTimer;
}

async function addToCart() {
    const $drawer = (function() {
        const btnAddShared = document.querySelector(QP_DRAWER + ' [data-id="btn-add-shared"]');
        return btnAddShared ?
            (btnAddShared.closest(QP_DRAWER) || document.querySelector(QP_DRAWER)) :
            document.querySelector(QP_DRAWER);
    })();

    const $error = $drawer ? $drawer.querySelector('.quick_personalize_personalized-error') : null;
    const loader = document.getElementById('cart-loader');

    clearTimeout(errorTimer);

    function showError(msg) {
        if (!$error) return;
        $error.classList.remove('hidden');
        $error.classList.add('active');
        $error.style.color = 'red';
        $error.textContent = msg;
        errorTimer = setTimeout(() => {
            $error.classList.remove('active');
            $error.classList.add('hidden');
        }, 3000);
    }

    function getEmbellishmentText(s) {
        const emb = s && s.embellishment;
        if (!emb) return '';
        const isOn = emb.enabled || emb.checked;
        const iconLabel = emb.iconName || emb.icon;
        if (!isOn || !iconLabel) return '';
        return 'Embellishment: ' + iconLabel + (emb.position ? ` (${emb.position})` : '');
    }

    const personalizeInput = $drawer ? $drawer.querySelector('.quick_personalize_personlize') : null;
    const personalizeId = personalizeInput ? personalizeInput.value : null;
    const data_name = personalizeInput ? personalizeInput.getAttribute('data-name') : null;
    const mainProductTitle = $drawer ? ($drawer.querySelector('.quick_personalize_personalised_header')?.getAttribute('data-product') || '') : '';

    const variantInput = $drawer ?
        $drawer.querySelector('.quick_personalize_product-variant-id') :
        document.querySelector('.quick_personalize_product-variant-id');
    if (!variantInput) {
        console.error('No variant input');
        return;
    }

    loader.style.display = 'flex';

    // Unique bundle id per main+addon pair for this call
    const bundleId = generateBundleId();

    // ---- Helper functions for building structured, human-readable line item properties ----

// Turns a field key like "front-engraving" / "back-engraving" / "inside-engraving"
// into a clean label: "Front", "Back", "Inside". Also works if the key is already
// just "front" / "back" with no "-engraving" suffix.
function deriveLabel(key) {
    const cleaned = key.replace(/[-_]?engraving$/i, '');
    const words = cleaned.split(/[-_]/).filter(Boolean);
    if (words.length === 0) return key;
    return words
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
}

// Does this side actually have content the customer entered?
function hasSideContent(side) {
    if (!side || !side.type) return false;
    if (side.type === 'text') {
        return (side.value || []).some(line => !!line);
    }
    if (side.type === 'icon') {
        return !!side.value;
    }
    if (side.type === 'image') {
        return !!side.rawFile || !!side.filename;
    }
    return false;
}

// Text lines, split into separate labeled properties
// e.g. "Front - Line 1": "test", "Front - Line 2": "dsfs", "Front - Line 3": "sad"
// Font is intentionally NOT included here — see getFontProps below,
// since it's shown once rather than duplicated per side.
function getTextProps(side, label) {
    const props = {};
    const lines = (side.value || []).filter(Boolean);
    lines.forEach((line, i) => {
        props[`${label} - Line ${i + 1}`] = line;
    });
    return props;
}

// Font style: shown once as a plain "Font Style" property when every side that
// has text uses the SAME font (the common case). If different sides genuinely
// use different fonts, falls back to "<Label> - Font Style" per side so nothing
// is lost.
function getFontProps(state) {
    const fontsByLabel = {};
    Object.keys(state).forEach(key => {
        const side = state[key];
        if (side && side.type === 'text' && side.fontName) {
            fontsByLabel[deriveLabel(key)] = side.fontName;
        }
    });

    const uniqueFonts = [...new Set(Object.values(fontsByLabel))];
    const props = {};
    if (uniqueFonts.length === 1) {
        props['Font Style'] = uniqueFonts[0];
    } else if (uniqueFonts.length > 1) {
        Object.entries(fontsByLabel).forEach(([label, font]) => {
            props[`${label} - Font Style`] = font;
        });
    }
    return props;
}

// Embellishment icon + position, split into separate labeled properties
// Assumes side.embellishment = { checked, iconName, iconImg, position }
function getEmbellishmentProps(side, label) {
    const props = {};
    const emb = side && side.embellishment;
    if (emb && emb.checked) {
        if (emb.iconName) props[`${label} - Embellishment Icon`] = emb.iconName;
        if (emb.position) props[`${label} - Embellishment Position`] = emb.position;
    }
    return props;
}

// ---- Add to cart ----
try {
    const hasImage = Object.values(state).some(side => side && side.type === 'image');

    if (hasImage) {
        const formData = new FormData();
        formData.append('id', variantInput.value);
        formData.append('quantity', '1');

        Object.keys(state).forEach(key => {
            const side = state[key];
            const label = deriveLabel(key);
            if (!hasSideContent(side)) return;

            if (side.type === 'text') {
                const props = getTextProps(side, label);
                Object.entries(props).forEach(([k, v]) => formData.append(`properties[${k}]`, v));
            } else if (side.type === 'icon') {
                formData.append(`properties[${label} - Icon]`, side.value || '');
            } else if (side.type === 'image' && side.rawFile) {
                formData.append(`properties[${label} - Image]`, side.rawFile, side.filename || `${key}-image.png`);
            }

            const embProps = getEmbellishmentProps(side, label);
            Object.entries(embProps).forEach(([k, v]) => formData.append(`properties[${k}]`, v));
        });

        Object.entries(getFontProps(state)).forEach(([k, v]) => formData.append(`properties[${k}]`, v));

        formData.append('properties[_bundle_id]', bundleId);

        const res1 = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res1.ok) throw new Error('Main product add failed');

        const res2 = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: personalizeId,
                quantity: 1,
                properties: {
                    '_linked': variantInput.value,
                    'Product added  with ': mainProductTitle,
                    '_personalise_product': 'true',
                    '_bundle_id': bundleId,
                    '_is_addon': 'true'
                }
            }),
        });
        if (!res2.ok) throw new Error('Personalize product add failed');

    } else {
        const properties = {
            'Personalize Product': data_name,
            '_personalise_product': 'true',
            '_bundle_id': bundleId
        };

        Object.keys(state).forEach(key => {
            const side = state[key];
            const label = deriveLabel(key);
            if (!hasSideContent(side)) return;

            if (side.type === 'text') {
                Object.assign(properties, getTextProps(side, label));
            } else if (side.type === 'icon') {
                properties[`${label} - Icon`] = side.value || '';
            }
            Object.assign(properties, getEmbellishmentProps(side, label));
        });

        Object.assign(properties, getFontProps(state));

        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [
                    {
                        id: variantInput.value,
                        quantity: 1,
                        properties
                    },
                    {
                        id: personalizeId,
                        quantity: 1,
                        properties: {
                            '_linked': variantInput.value,
                            'Product added  with ': mainProductTitle,
                            '_personalise_product': 'true',
                            '_bundle_id': bundleId,
                            '_is_addon': 'true'
                        }
                    }
                ]
            }),
        });
        if (!res.ok) throw new Error('Cart add failed');
    }

    await refreshCartDrawer();
    resetDrawerState($drawer);

} catch (err) {
    console.error('Add to cart error:', err);
    showError('Something went wrong. Please try again.');
} finally {
    loader.style.display = 'none';
}
}
window.addToCart = addToCart;

function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer')
        .then(res => {
            const contentType = res.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new Error(`Expected JSON but got: ${contentType}`);
            }
            return res.json();
        })
        .then(data => {
            if (!data['cart-drawer']) {
                console.warn('cart-drawer section not found. Available keys:', Object.keys(data));
                return fetch('/cart.js');
            }
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
            const newDrawer = newDoc.querySelector('cart-drawer');
            const curDrawer = document.querySelector('cart-drawer');
            if (newDrawer && curDrawer) {
                curDrawer.innerHTML = newDrawer.innerHTML;
                curDrawer.classList.remove('is-empty');
                curDrawer.classList.add('active');
                curDrawer.scrollTop = 0;
            }
            const personaliseDrawer = qpActiveDrawer();
            if (personaliseDrawer) {
                personaliseDrawer.classList.remove('active');
                personaliseDrawer.classList.add('hidden');
            }
            document.querySelectorAll('.Personalise_button').forEach(b => b.classList.remove('active'));

            return fetch('/cart.js');
        })
        .then(res => res.json())
        .then(cart => {
            const countEl = document.querySelector('.cart-count');
            if (countEl) countEl.textContent = cart.item_count;
        })
        .catch(err => console.error('Error refreshing cart drawer:', err));
}

/**
 * Pre-fill a drawer's state + UI from a saved snapshot.
 */
window.loadPersonaliseState = function(ps, targetDrawer) {
    if (!ps) return;

    var sides = window.ENGRAVING_SIDES || [];

    sides.forEach(function(sideObj) {
        var slug = sideObj.slug;
        var incoming = ps[slug];
        if (!incoming) return;

        window._personaliseState[slug] = Object.assign({}, window._personaliseState[slug], incoming);
        if (incoming.embellishment) {
            window._personaliseState[slug].embellishment = Object.assign({}, incoming.embellishment);
        }
        window._personaliseState[slug].rawFile = null;

        if (window._personaliseState[slug].type === 'image') {
            var st = window._personaliseState[slug];
            if (isDataUrl(st.imageData)) {
                
                var rebuilt = dataUrlToFile(st.imageData, st.filename);
                if (rebuilt) {
                    st.rawFile = rebuilt;
                    st.needsReupload = false;
                } else {
                    st.needsReupload = true; 
                }
            } else {
                st.needsReupload = true;
            }
        }
    });

    var drawer = targetDrawer || qpAnyDrawer();
    if (!drawer) return;

    buildIconGrids();

    var firstFilledSide = null;

    sides.forEach(function(sideObj) {
        var side = sideObj.slug;
        var s = window._personaliseState[side];
        if (!s || !s.type) return;

        if (!firstFilledSide) firstFilledSide = side;

        drawer.querySelectorAll('.quick_personalize_mode-btn[data-side="' + side + '"]').forEach(function(b) {
            b.classList.toggle('active', b.dataset.mode === s.type);
        });
        ['text', 'image', 'icon'].forEach(function(m) {
            var panel = drawer.querySelector(`[data-id="${side}-${m}"]`);
            if (panel) panel.classList.toggle('active', m === s.type);
        });
        if (typeof activeMode === 'object') activeMode[side] = s.type;

        if (s.type === 'text') {
            var inputs = drawer.querySelectorAll('.quick_personalize_field-input[data-side="' + side + '"]');
            (s.value || []).forEach(function(val, i) {
                if (inputs[i]) {
                    inputs[i].value = val || '';
                    var row = inputs[i].closest('.quick_personalize_field-row');
                    var small = row ? row.querySelector('.quick_personalize_char-count') : null;
                    var maxLength = inputs[i].getAttribute('maxlength');
                    if (small) small.textContent = (val ? val.length : 0) + `/${maxLength}`;
                }
            });
            var fontSel = drawer.querySelector('.quick_personalize_font-select[data-side="' + side + '"]');
            if (fontSel) {
                fontSel.value = s.fontName || '';
                selectedFonts[side] = s.fontName || '';
            }
           updatePreview(side, drawer);  

        } else if (s.type === 'image') {
            if (s.imageData) {
                var imgEl = drawer.querySelector(`[data-id="${side}-img-preview"]`);
                var nameEl = drawer.querySelector(`[data-id="${side}-img-name"]`);
                var zone = drawer.querySelector(`[data-id="upload-zone-${side}"]`);
                if (imgEl) {
                    imgEl.src = s.imageData;
                    imgEl.style.display = 'block';
                }
                if (nameEl) {
                    nameEl.textContent = s.filename || '';
                    nameEl.style.display = 'block';
                }
                if (zone) {
                    zone.classList.add('has-file');
                    var ut = zone.querySelector('.quick_personalize_upload-text');
                    var ui = zone.querySelector('.upload-icon');
                    if (ut) ut.style.display = 'none';
                    if (ui) ui.style.display = 'none';
                }
            }

        } else if (s.type === 'icon') {
            drawer.querySelectorAll('.quick_personalize_icon-item[data-side="' + side + '"]').forEach(function(item) {
                item.classList.toggle('selected', item.dataset.iconName === s.value);
            });
            var p = drawer.querySelector('[data-id="' + side + '-icon"]');
            var sp = p ? p.querySelector('.quick_personalize_embellisment_icon') : null;
            if (sp && s.value) sp.textContent = s.value;
        }

        if (s.embellishment) {
            bybApplyEmbellishmentToUI(drawer, side, s.type, s.embellishment);
        }

        updateSplitPreview(side, drawer);
    });

    updateStateBar(drawer);

    var landingSide = firstFilledSide || (sides.length ? sides[0].slug : null);
    if (landingSide) {
        switchMainTab(landingSide);
        window.lastEditedSide = landingSide;
    }
};

//helper

function bybShowFieldError(drawer, id, msg, invalidEl) {
    if (!drawer) return;
    var el = drawer.querySelector('[data-id="' + id + '"]');
    if (el) {
        el.textContent = msg;
        el.classList.remove('hidden');
        el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    if (invalidEl) invalidEl.classList.add('is-invalid');
}

function bybClearFieldErrors(drawer, side) {
    if (!drawer) return;
    var scope = side
        ? drawer.querySelector('.quick_personalize_tab-panel[data-side="' + side + '"]') || drawer
        : drawer;
    scope.querySelectorAll('.quick_personalize_field-error, .quick_personalize_checkbox-error').forEach(function (el) {
        el.classList.add('hidden');
        el.textContent = '';
    });
    scope.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
    });
}
window.bybShowFieldError = bybShowFieldError;
window.bybClearFieldErrors = bybClearFieldErrors;

document.addEventListener('change', function (e) {
    var sel = e.target.closest('.quick_personalize_font-select');
    if (sel) {
        var d = sel.closest(QP_DRAWER);
        var errEl = d && d.querySelector('[data-id="font-error-' + sel.dataset.side + '"]');
        if (sel.value && errEl) { errEl.classList.add('hidden'); sel.classList.remove('is-invalid'); }
        return;
    }

    var cb = e.target.closest('.quick_personalize_terms-checkbox input[type="checkbox"]');
    if (cb && cb.checked) {
        var wrap = cb.closest('.quick_personalize_terms-wrapper');
        var box = wrap && wrap.querySelector('.quick_personalize_checkbox-error');
        if (box) { box.classList.add('hidden'); box.textContent = ''; }
        cb.classList.remove('is-invalid');
    }
});

function bybValidateSide(drawer, side, opts) {
    var panel = drawer.querySelector('.quick_personalize_tab-panel[data-side="' + side + '"]');
    if (!panel) return true;

    var mode = (window._byb_activeMode && window._byb_activeMode[side]) || 'text';
    var st = window._personaliseState[side] || {};

    bybClearFieldErrors(drawer, side);

    var inputs = drawer.querySelectorAll('.quick_personalize_field-input[data-side="' + side + '"]');
    var hasText = Array.from(inputs).some(function (i) { return i.value.trim(); });

    var touched =
        (mode === 'text'  && hasText) ||
        (mode === 'image' && st.type === 'image' && st.imageData) ||
        (mode === 'icon'  && st.type === 'icon');

    if (!touched && !(opts && opts.required)) return true;


    if (mode === 'text') {
        var lines = Array.from(inputs).map(function (i) { return i.value.trim(); });

        if (!lines.some(Boolean)) {
            bybShowFieldError(drawer, 'text-error-' + side,
                'Please enter your engraving text.', inputs[0]);
            return false;
        }

        if (panel.getAttribute('data-font-compulsory') === 'true') {
            var fontSel = drawer.querySelector('.quick_personalize_font-select[data-side="' + side + '"]');
            if (fontSel && !fontSel.value) {
                bybShowFieldError(drawer, 'font-error-' + side,
                    'Please select a font style as this is required.', fontSel);
                return false;
            }
        }

        if (panel.getAttribute('data-terms-required') === 'true') {
            var cb = drawer.querySelector('[data-id="terms-check-' + side + '-text"]');
            if (cb && !cb.checked) {
                bybShowFieldError(drawer, 'terms-error-' + side + '-text',
                    'Please accept the terms & conditions to continue.', cb);
                return false;
            }
        }
    }

    if (mode === 'image') {
        if (st.type !== 'image' || !st.imageData) {
            bybShowFieldError(drawer, 'upload-error-' + side, 'Please upload an image.');
            return false;
        }
        if (st.needsReupload) {
            bybShowFieldError(drawer, 'upload-error-' + side,
                'Please re-upload your image ');
            return false;
        }
        if (panel.getAttribute('data-terms-required-image') === 'true') {
            var cbi = drawer.querySelector('[data-id="terms-check-' + side + '-image"]');
            if (cbi && !cbi.checked) {
                bybShowFieldError(drawer, 'terms-error-' + side + '-image',
                    'Please accept the terms & conditions to continue.', cbi);
                return false;
            }
        }
    }

    if (mode === 'icon' && st.type !== 'icon') {
        bybShowFieldError(drawer, 'icon-error-' + side, 'Please select an embellishment.');
        return false;
    }

    return true;
}
window.bybValidateSide = bybValidateSide;

document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quick_personalize_btn-review');
    if (!btn) return;
    if (btn.classList.contains('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        // still show why, so a dead button isn't a mystery
        bybValidateSide(btn.closest(QP_DRAWER), btn.dataset.side);
        return;
    }
    handleReview(btn.dataset.side, btn.dataset.mode);
});

function bybSideIsValid(drawer, side) {
    var panel = drawer.querySelector('.quick_personalize_tab-panel[data-side="' + side + '"]');
    if (!panel) return true;
    var mode = (window._byb_activeMode && window._byb_activeMode[side]) || 'text';
    var st = window._personaliseState[side] || {};

    if (mode === 'text') {
        var inputs = drawer.querySelectorAll('.quick_personalize_field-input[data-side="' + side + '"]');
        if (!Array.from(inputs).some(i => i.value.trim())) return false;
        if (panel.getAttribute('data-font-compulsory') === 'true') {
            var f = drawer.querySelector('.quick_personalize_font-select[data-side="' + side + '"]');
            if (f && !f.value) return false;
        }
        if (panel.getAttribute('data-terms-required') === 'true') {
            var cb = drawer.querySelector('[data-id="terms-check-' + side + '-text"]');
            if (cb && !cb.checked) return false;
        }
    } else if (mode === 'image') {
        if (st.type !== 'image' || !st.imageData || st.needsReupload) return false;
        if (panel.getAttribute('data-terms-required-image') === 'true') {
            var cbi = drawer.querySelector('[data-id="terms-check-' + side + '-image"]');
            if (cbi && !cbi.checked) return false;
        }
    } else if (mode === 'icon') {
        if (st.type !== 'icon') return false;
    }
    return true;
}

function bybRefreshSideButtons(drawer, side) {
    if (!drawer) return;
    var ok = bybSideIsValid(drawer, side);
    var mode = (window._byb_activeMode && window._byb_activeMode[side]) || 'text';

    drawer.querySelectorAll('.quick_personalize_btn-review[data-side="' + side + '"][data-mode="' + mode + '"]')
        .forEach(b => b.classList.toggle('disabled', !ok));

    // single-mode layout: the add button sits where review would
    var panel = drawer.querySelector(`[data-id="${side}-${mode}"]`);
    if (panel) {
        panel.querySelectorAll('[data-id="btn-add-shared_personlize"]')
            .forEach(b => b.classList.toggle('disabled', !ok));
    }
}
window.bybRefreshSideButtons = bybRefreshSideButtons;

function bybValidateReviewTerms(drawer) {
    if (!drawer) return true;

    var box = drawer.querySelector('[data-id="terms-check--all"]');
    if (!box) return true;

    var errEl = drawer.querySelector('[data-id="terms-error--all"]');

    if (!box.checked) {
        if (errEl) {
            clearTimeout(errEl._bybHideTimer);

            errEl.textContent = 'Please accept the terms & conditions to continue.';
            errEl.classList.remove('hidden');
            errEl.scrollIntoView({ block: 'center', behavior: 'smooth' });

            errEl._bybHideTimer = setTimeout(function () {
                errEl.classList.add('hidden');
                errEl.textContent = '';
                box.classList.remove('is-invalid');
            }, 4000);
        }
        box.classList.add('is-invalid');
        return false;
    }

    if (errEl) {
        clearTimeout(errEl._bybHideTimer);
        errEl.classList.add('hidden');
        errEl.textContent = '';
    }
    box.classList.remove('is-invalid');
    return true;
}
window.bybValidateReviewTerms = bybValidateReviewTerms;

document.addEventListener('change', function (e) {
    var all = e.target.closest('[data-id="terms-check--all"]');
    if (!all) return;

    var d = all.closest(QP_DRAWER);
    if (!d) return;

    d.querySelectorAll('.quick_personalize_tab-panel .quick_personalize_terms-checkbox input[type="checkbox"]')
        .forEach(function (cb) { cb.checked = all.checked; });

    if (all.checked) {
        bybClearFieldErrors(d);
    }
});

document.addEventListener('change', function (e) {
    var cb = e.target.closest('.quick_personalize_tab-panel .quick_personalize_terms-checkbox input[type="checkbox"]');
    if (!cb) return;

    var d = cb.closest(QP_DRAWER);
    if (!d) return;

    var all = d.querySelector('[data-id="terms-check--all"]');
    if (!all) return;

    var boxes = d.querySelectorAll('.quick_personalize_tab-panel .quick_personalize_terms-checkbox input[type="checkbox"]');
    all.checked = Array.from(boxes).every(function (b) { return b.checked; });
});

//helper
function isDataUrl(v) { return typeof v === 'string' && v.indexOf('data:') === 0; }

function dataUrlToFile(dataUrl, filename) {
    try {
        var parts = String(dataUrl).split(',');
        var mime = (/data:([^;]+)/.exec(parts[0]) || [])[1] || 'image/png';
        var binary = atob(parts[1]);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        return new File([bytes], filename || 'image.png', { type: mime });
    } catch (e) {
        console.warn('[personalise] could not rebuild file from data URL:', e);
        return null;
    }
}

function bybApplyEmbellishmentToUI(drawer, side, mode, emb) {
    if (!drawer || !emb) return;

    var panel = drawer.querySelector(`[data-id="${side}-${mode}"]`);
    if (!panel) return;

    var cb   = panel.querySelector('.quick_personalize_embellishment-check');  // ←
    var wrap = panel.querySelector('.quick_personalize_embellishment-icons');  // ←
    var isOn = !!(emb.checked || emb.enabled);

    if (cb) cb.checked = isOn;
    if (wrap) wrap.classList.toggle('hidden', !isOn);

    if (!isOn) return;

    var name = emb.iconName || emb.icon || '';
    if (name && wrap) {
        wrap.querySelectorAll('.quick_personalize_icon-item').forEach(function (it) {
            it.classList.toggle('selected', it.dataset.iconName === name);
        });
    }

    if (emb.position) {
        var pos = panel.querySelector(
            `[name="embellishment-position"][value="${emb.position}"]`               // ←
        );
        if (pos) pos.checked = true;
    }

    var label = panel.querySelector('.quick_personalize_embellisment_icon');
    if (label && name) label.textContent = name;
}
window.bybApplyEmbellishmentToUI = bybApplyEmbellishmentToUI;